import axios from "../../config/axiosConfig";
import {
  CREATE_WORKER_ATTENDANCE_DAILY, DELETE_WORKER_ATTENDANCE_DAILY,
  GET_WORKER_ATTENDANCE_DAILY,
  WORKER_ATTENDANCE_DAILY_REQUEST,
  WORKER_ATTENDANCE_DAILY_REQUEST_FAILURE,
  UPDATE_WORKER_ATTENDANCE_DAILY
} from "../types/worker-attendance-daily-types";

export const getWorkerAttendanceDaily = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: WORKER_ATTENDANCE_DAILY_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/worker-attendance-daily/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_WORKER_ATTENDANCE_DAILY, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WORKER_ATTENDANCE_DAILY_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WORKER_ATTENDANCE_DAILY_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createWorkerAttendanceDaily = (workerAttendanceDaily) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: WORKER_ATTENDANCE_DAILY_REQUEST });
      const newWorkerAttendanceDaily = {
        ...workerAttendanceDaily
      };
      return axios.post("/worker-attendance-daily/add", newWorkerAttendanceDaily,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_WORKER_ATTENDANCE_DAILY, payload: response.data });
        } else {
          dispatch({
            type: WORKER_ATTENDANCE_DAILY_REQUEST_FAILURE,
            error: "Worker Attendance Daily create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WORKER_ATTENDANCE_DAILY_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WORKER_ATTENDANCE_DAILY_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateWorkerAttendanceDaily = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: WORKER_ATTENDANCE_DAILY_REQUEST });
      const { auth } = getState();
      return axios.put("/worker-attendance-daily/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_WORKER_ATTENDANCE_DAILY,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: WORKER_ATTENDANCE_DAILY_REQUEST_FAILURE,
            error: "Worker Attendance Daily update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WORKER_ATTENDANCE_DAILY_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WORKER_ATTENDANCE_DAILY_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteWorkerAttendanceDaily = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: WORKER_ATTENDANCE_DAILY_REQUEST });
      return axios.delete(`/worker-attendance-daily/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_WORKER_ATTENDANCE_DAILY, id: id });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WORKER_ATTENDANCE_DAILY_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WORKER_ATTENDANCE_DAILY_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};